import { LOCATION_CHANGE, LocationChangeAction } from 'react-router-redux';
import { AnyAction } from 'redux';
import { ActionsObservable, combineEpics, ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { filter, map, switchMap } from 'rxjs/operators';

import { LOGGING_IN, LOGGING_OUT } from './actions';
import auth from '../auth/auth';
import config from '../config';

// Reducer
export type AuthState = {
  isLoggingIn: boolean;
};

const defaultState: AuthState = {
  isLoggingIn: false,
};
export const authReducer = (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case LOGGING_IN: {
      return { ...state, isLoggingIn: true };
    }
    default:
      return state;
  }
};

// Epics
const login$ = (action$: ActionsObservable<LocationChangeAction>) =>
  action$.pipe(
    ofType(LOCATION_CHANGE),
    filter((action) => !auth.isAuthenticated() && !['/callback'].includes(action.payload.pathname)),
    map(() => {
      auth.login();
      return { type: LOGGING_IN };
    })
  );

const logout$ = (action$: ActionsObservable<AnyAction>) =>
  action$.pipe(
    ofType(LOGGING_OUT),
    switchMap(() => {
      auth.logout();

      const url = `${config.apiUrl}/logout`;
      const ajaxRequest = { url, method: 'POST', withCredentials: true };
      return ajax(ajaxRequest);
    })
  );

export const authEpic = combineEpics(login$, logout$);
